import { render, staticRenderFns } from "./DuplicationReasonRequirementSummary.vue?vue&type=template&id=5c97490c&scoped=true"
import script from "./DuplicationReasonRequirementSummary.vue?vue&type=script&lang=ts"
export * from "./DuplicationReasonRequirementSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c97490c",
  null
  
)

export default component.exports